<template>
	<div >
		<div class="page-block mb-5 d-flex justify-content-start align-items-start terms__heading"  key="submit-block">
			<input class="terms-checkbox" id="marketing-checkbox" type="checkbox" v-model="isMarketingConsentChecked" />
			<div class="d-flex align-items-center">
				<label for="marketing-checkbox" :class="{small}">{{ $t('shared.marketing_consent.check_box_text') }}</label>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'MarketingConsent',
		props: {
			small: {
				type: Boolean,
				default() {
					return false
				},
			},
		},
		watch: {
			isMarketingConsentChecked(newVal) {
				this.$emit('stateChanged', newVal)
				if (newVal) {
					this.$emit('sendAnalytic', 'product-purchase-marketing-consent-agreed')
				} else {
					this.$emit('sendAnalytic', 'product-purchase-marketing-consent-rejected')
				}
			},
		},
		data() {
			return {
				isMarketingConsentChecked: false,
			}
		},
	}
</script>

<style lang="scss" scoped>
	.terms-checkbox {
		/* Add if not using autoprefixer */
		-webkit-appearance: none;
		appearance: none;
		/* For iOS < 15 to remove gradient background */
		background-color: transparent;
		/* Not removed via appearance */
		margin: 2px;
		margin-right: 10px;
		font: inherit;
		color: var(--stan-store-theme-primary-color, var(--stan-user-primary-color, var(--stan-store-default-color)));
		width: 1.3em;
		height: 1.3em;
		aspect-ratio: 1;
		border: 0.15em solid var(--stan-store-theme-primary-color, var(--stan-user-primary-color, var(--stan-store-default-color)));
		display: grid;
		place-content: center;
		&::before {
			content: '';
			width: 1em;
			height: 1em;
			transform: scale(0);
			transition: 0.3s transform ease-in-out;
			transform-origin: bottom left;
			clip-path: polygon(99% 21%, 35% 88%, 0% 51%, 10% 41%, 35% 68%, 88% 11%, 99% 21%);
			box-shadow: inset 1em 1em var(--stan-store-theme-button-text-color, #ffffff);
			border-radius: 0.15em;
		}
		&:checked::before {
			transform: scale(1);
		}
		&:checked {
			background-color: var(--stan-store-theme-primary-color, var(--stan-user-primary-color, var(--stan-store-default-color)));
		}
	}

	label.small { 
		font-size: 14px;
	}
</style>
